import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ImpersonationBanner } from './ImpersonationBanner';
import { useDashboardTheme } from '@/hooks/useDashboardTheme';
import { EnvironmentBadge } from '@/components/EnvironmentBadge';

export function MainLayout() {
  // Apply theme class based on user role (superadmin vs tenantadmin)
  useDashboardTheme();

  return (
    <div className="min-h-screen bg-background flex">
      <EnvironmentBadge />
      <Sidebar />
      <div className="admin-shell-content min-w-0 flex-1 flex flex-col transition-all">
        <Header />
        <ImpersonationBanner />
        <main className="flex-1 p-[var(--admin-content-padding)] overflow-x-hidden">
          <div className="admin-page-content space-y-[var(--admin-page-gap)] animate-in fade-in slide-in-from-bottom-4 duration-500">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
